import matrix from './permissions.json';

// Who may open which surface. The table itself is GENERATED from
// services/data-pipeline/internal/authz — never hand-edit permissions.json.
// Regenerate with:
//
//   cd services/data-pipeline && \
//     go test ./internal/authz -run TestPermissionsJSONMatchesTheMatrix -update
//
// Go is the source of truth because the backend is where a denial actually
// matters; this module exists so the nav and the router can agree with it without
// a round trip. A frontend that disagreed would hide a link the API still serves,
// or show one it refuses — both are bugs, and generating removes the possibility.
//
// Design: docs/superpowers/specs/2026-08-08-role-feature-permissions-design.md

// FEATURES names the surfaces. Constants rather than string literals at call
// sites, so a typo is a missing export rather than a permission that silently
// reads false forever — the same reasoning as FlagProvider's FLAGS.
export const FEATURES = {
  candidateGraph: 'candidate_graph',
  targetedOutreach: 'targeted_outreach',
  dataQuality: 'data_quality',
  signalSources: 'signal_sources',
  deepResearch: 'deep_research',
  manageTeam: 'manage_team',
  adminConsole: 'admin_console',
};

// can answers whether role may use feature. Fails CLOSED: an unknown role, an
// unknown feature, or a missing either all deny. No match must never mean allow.
export function can(role, feature) {
  const roles = matrix.features[feature];
  return Array.isArray(roles) && roles.includes(role);
}

// homeFor is the landing path for a role — after login, after setting a password,
// and the target of the 404 page's button. It comes from the same table as can(),
// so it cannot point at a page that role is denied.
//
// The '/login' fallback mirrors internal/authz's homeFallback. It is reachable
// only if the auth service ever returns a user with no usable role, which is a
// bug; sending them to the login screen is the honest response to it.
export function homeFor(role) {
  return matrix.home[role] || '/login';
}
